<template>
  <div class="generate-trailer h-full">
    <line-by-line tag="h1" class="h1" v-html="$t('teaser.in_progress')" />

    <ImagesTrail />
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import ImagesTrail from "@/components/animations/ImagesTrail.vue";
import Router from "@/core/Router";
import { posterStore } from "@/store/modules/Poster";
import { setFinalVideo } from "@/store/modules/Video";
import { useI18n } from "vue-i18n";

const { locale } = useI18n();
const convertLang = [
  {
    lang: 'en',
    codeIS: 'UCAN'
  }, {
    lang: 'fr',
    codeIS: 'FRANCE'
  }, {
    lang: 'de',
    codeIS: 'GERMANY'
  }, {
    lang: 'it',
    codeIS: 'ITALY'
  }, {
    lang: 'ja',
    codeIS: 'JAPAN'
  }, {
    lang: 'es',
    codeIS: 'LATAM'
  }, {
    lang: 'pt',
    codeIS: 'BRAZIL'
  }
];

const posterURL = computed(() => posterStore.url);
onMounted(async() => {
  const lang = convertLang.find(l => l.lang === locale.value).codeIS;

  await greCaptchaReady()
  // @ts-ignore
  const token = await grecaptcha.execute(process.env.VUE_APP_RECAPTCHA_SITE_KEY, { action: 'submit' })
  generateTrailer(lang, token);

  // setTimeout(() => {
  //   Router.push({ name: 'ShowTrailer' });
  // }, 1000);
})

const generateTrailer = (lang, token) => {
  const posterBase64 = posterURL.value;
  const blob = dataURItoBlob(posterBase64);
  const formData = new FormData();
  formData.append('file', blob, 'poster.jpg');
  formData.append('language', lang);
  formData.append('g-recaptcha-response', token);

  const requestOptions = {
    method: 'POST',
    body: formData,
    redirect: 'follow'
  };

  fetch(`${process.env.VUE_APP_API_BASE_URL}save`, requestOptions)
    .then(response => response.text())
    .then(result => {
      const { url } = JSON.parse(result);
      setFinalVideo(url);
      Router.push({ name: 'ShowTrailer' });
    })
    .catch(error => console.log('error', error));
}

const greCaptchaReady = () => {
  return new Promise(resolve => {
    // @ts-ignore
    grecaptcha.ready(function() {
      return resolve()
    });
  })
}

function dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1]);
    else
        byteString = unescape(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], {type:mimeString});
}
</script>

<style lang="stylus" scoped>
.generate-trailer
  position relative
  display flex
  flex-direction column
  align-items center
  justify-content center

  .h1
    position relative
    text-align center
    z-index 1
</style>